import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});

let navigateFunction;

export const setNavigateFunction = (navigate) => {
  navigateFunction = navigate;
};

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      navigateFunction &&
      (error.response.status === 403 || error.response.status === 401)
    ) {
      sessionStorage.clear();
      navigateFunction("/login", {
        state: { error: error?.response?.data?.error },
      });
    }
    return Promise.reject(error);
  }
);

export default api;
